export const iconFontAwesomePunctuationSymbolsQuestion = (
	<i className="fa-solid fa-question"></i>
);
